<!-- eslint-disable -->
<template lang="pug">
    .play-box(class="play-box_limited")
        template(v-if="!isLoading")
            game-header(
                v-if="!isBattle"
                @soundStateChanged="headerKey = !headerKey",
                :key="headerKey",
                :time='getTime'
                :slug="type"
                :game-type="parameters && parameters.courseType"
                :is-homework="!!exerciseId"
            )
            .play-box__game(v-if='gameStarted && !gameFinished')
                .play-box__example
                    scaling-bar(v-model="fontSizeCoefficient")
                    sound-player(
                        :file="example.sound | apiFile"
                        :playbackSpeed="parameters.playbackSpeed"
                    )
                    .checked-user-answer(:style="{borderBottom: rightAnswerGiven && '2px solid hsl(121, 38%, 58%)'}")
                        div(
                            v-if="!showRightAnswersClicked"
                            v-for="answer in userAnswerArray"
                            v-html="answer.symbol"
                            :style="{borderBottom: !answer.correct ? answer.isRedBorder && '2px solid red' || '2px solid #000' : 'none', fontSize: fontSizeCoefficient + 'em', marginRight: !answer.correct ? '1px' : '0px', width: !answer.correct && '0.6em'}"
                        )
                        div(
                            v-if="showRightAnswersClicked"
                            v-for="answer in correctAnswerArray"
                            v-html="answer.symbol"
                            :style="{borderBottom: '2px solid #6BBD6DFF', fontSize: fontSizeCoefficient + 'em'}"
                        )
                    textarea.input-area.trainer-modal-content__textarea(
                        v-if="!isDictationMode"
                        v-on:contextmenu.prevent="disableContextMenu"
                        v-focus="true"
                        :disabled="rightAnswerGiven"
                        v-model="userAnswer",
                        :placeholder="$i18n.t('trainer.trainer_textsModal_textInput')"
                        :style="{fontSize: fontSizeCoefficient + 'em'}"
                    )
                    cs-button.play-box__next-example-button(
                        v-if="!isDictationMode && !rightAnswerGiven && !showRightAnswersClicked"
                        @click="processReply()",
                        pattern="primary-outline",
                        color="blue"
                        :disabled="!userAnswer"
                    )  {{ $i18n.t('trainer.trainer_gamePlayBox_checkAnswer') }}
                    cs-button.play-box__next-example-button(
                        v-if="!isDictationMode && !rightAnswerGiven && showRightAnswersButton && !showRightAnswersClicked"
                        @click="showRightAnswer",
                        pattern="primary-outline",
                        color="blue"
                    )  {{ $i18n.t('trainer.trainer_game_showRightAnswer') }}
                    cs-button.play-box__next-example-button(
                        v-if="!isDictationMode && rightAnswerGiven || showRightAnswersClicked"
                        @click="nextExample",
                        pattern="primary-outline",
                        color="blue"
                    )  {{ $i18n.t('olympiads.olympiads_processStage_further') }}
                .game-info__block
                    game-info(
                        :score="{left: answers.good, right: answers.bad}"
                        :time="getTime"
                        :slug="type"
                        :parameters="parameters"
                        :game-allows-tips="false"
                        :opponent="opponent"
                        :opponent-numbers="opponentNumbers"
                        :is-opponent-answering="isOpponentAnswering"
                        :is-from-battle="isBattle"
                        :is-olympiad="isOlympiad"
                    )
            .divide-it-right__answer-buttom(v-if='isDictationMode && gameFinished && !showAnswersInDictationMode')
                img.divide-it-right__answer-turtle(:src="turtle")
                cs-button(@click='showAnswerInDictationMode' v-focus='')
                    | {{ $i18n.t('trainer.trainer_gamePlayBox_showAnswers') }}
            examples-viewer(
                v-if="showAnswersInDictationMode"
                :examples-array="arrayOfDataForDictationMode"
            )
            .play-box__end-container(v-if='gameFinished && !isDictationMode && !isOlympiad')
                fireworks(:is-mobile="isMobile")
                .play-box__reaction-container
                    .play-box__answers.play-box__answers--left
                        | {{ $i18n.t('trainer.trainer_game_wordField_yourTime') }}
                        br
                        | {{ getTime }}
                    result-image.play-box__image(:status="gameResult")
                    .play-box__answers.play-box__answers--right
                        | {{ $i18n.t('dashboard.dashboard_sidebar_statistics') }}
                        br
                        | {{ answers.good }} / {{ answers.bad }}
                result-buttons(
                    v-if="!isBattle"
                    :exercise-id="exerciseId"
                    :games-type="parameters.courseType"
                    show-restart-button
                    @restartGame="restartGame"
                )
                    slot
            calculating-answers(v-if="calculatingAnswers" :is-last-game-in-battle="isLastGameInBattle")
        cs-loader(v-else)
</template>

<script>
    /*eslint-disable*/
    import { cloneDeep } from 'lodash';
    import playBoxGameMixin from '../../../../utils/trainer/playBoxGameMixin.js';
    import Battle from '../../../../utils/battle/battleMixin';
    import olympiadRussianLanguageAnswerTimerMixin from '../../../../utils/olympiads/olympiadRussianLanguageAnswerTimerMixin.js';
    import SoundPlayer from './SoundPlayer.vue';
    import ScalingBar from './ScalingBar.vue';
    import orthographGameItems from '@/api/games/orthograph';
    import ExamplesViewer from './ExamplesViewer.vue';
    import CalculatingAnswers from '../../CalculatingAnswersModal.vue';

    function DEFAULT_DATA() {
        return {
            fontSizeCoefficient: 2.5,
            example: null,
            userAnswer: '',
            userAnswerArray: [],
            answers: {
                good: 0,
                bad: 0,
            },
            prevUserAnswers: null,
            rightAnswerGiven: false,
            currentLevel: 1,
            givenAnswersInARow: 0,
            showRightAnswersClicked: false,
            arrayOfDataForDictationMode: [],
            showAnswersInDictationMode: false,
        };
    }

    export default {
        mixins: [playBoxGameMixin, Battle, olympiadRussianLanguageAnswerTimerMixin],
        data() {
            return DEFAULT_DATA();
        },
        components: {
            ExamplesViewer,
            SoundPlayer,
            ScalingBar,
            CalculatingAnswers,
        },
        mounted() {
            document.addEventListener('keydown', this.handleKeyPress);
        },
        beforeDestroy() {
            document.removeEventListener('keydown', this.handleKeyPress);
        },
        watch: {
            time: {
                handler(val) {
                    if (this.isDictationMode && val % this.parameters?.timeForAnswer === 0) {
                        this.nextExample();
                    }
                },
            },
        },
        computed: {
            turtle() {
                return require(`../../../../assets/images/turtle/ru/ru_AnswerTurtle.svg`);
            },
            correctAnswerArray() {
                return this.example.content.split('').map((symbol, index) => {
                    return {
                        symbol: symbol === ' ' ? '&nbsp;' : symbol,
                        correct: true,
                    };
                });
            },
            isDictationMode() {
                return this.parameters.dictation;
            },
            isInfiniteAmountOfExamples() {
                return this.parameters.timeLimit || this.parameters.infinityAmountOfExamples;
            },
            gameResult() {
                if (this.answers.good >= this.answers.bad) return 'success';
                else return 'failure';
            },
            showRightAnswersButton() {
                return this.givenAnswersInARow >= 3 && this.parameters.showAnswer;
            },
        },
        methods: {
            disableContextMenu(event) {
                event.preventDefault();
            },
            handleKeyPress(event) {
                if (event.key === 'Enter' && !this.gameFinished) {
                    if (this.userAnswer && !this.isDictationMode && !this.rightAnswerGiven && !this.showRightAnswersClicked) {
                        return this.processReply();
                    }
                    if (!this.isDictationMode && this.rightAnswerGiven || this.showRightAnswersClicked) {
                        return this.nextExample();
                    }
                }
            },
            processReply(finishExample = false) {
                this.givenAnswersInARow++;
                this.userAnswerArray = this.userAnswer.trim().split('').map((symbol, index) => {
                    const obj = {
                        symbol: symbol === ' ' ? '&nbsp;' : symbol,
                        correct: false,
                        isRedBorder: false,
                    };
                    if (index >= this.correctAnswerArray.length) {
                        obj.symbol = '&nbsp;';
                        return obj;
                    }
                    const formattedSymbol = symbol === ' ' ? '&nbsp;' : symbol;
                    const correctSymbol = this.correctAnswerArray[index].symbol;
                    const checkRegisterInCorrectSymbol = correctSymbol.toUpperCase() === correctSymbol;
                    if (!checkRegisterInCorrectSymbol) {
                        obj.correct = this.correctAnswerArray[index].symbol.toLowerCase() === formattedSymbol.toLowerCase();
                    } else {
                        obj.correct = this.correctAnswerArray[index].symbol === formattedSymbol
                    }
                    return obj;
                });
                this.userAnswerArray.forEach((obj, index) => {
                    if (index < this.userAnswerArray.length - 1) {
                        obj.isRedBorder = this.checkDoubledSigns(obj.symbol, this.userAnswerArray[index + 1].symbol);
                        if (obj.isRedBorder) {
                            obj.correct = false;
                        }
                    }
                    if (!obj.correct) {
                        obj.symbol = '&nbsp;';
                    }
                })
                while (this.userAnswerArray.length < this.correctAnswerArray.length) {
                    this.userAnswerArray.push({
                        symbol: '&nbsp;',
                        correct: false,
                        isRedBorder: false,
                    });
                }
                if (!this.prevUserAnswersArray) {
                    this.userAnswerArray.forEach(obj => {
                        if (obj.correct) this.answers.good++;
                        else this.answers.bad++;
                    });
                } else {
                    this.userAnswerArray.forEach((obj, index) => {
                        if (obj.correct !== this.prevUserAnswersArray[index]?.correct) {
                            if (obj.correct) this.answers.good++;
                            else this.answers.bad++;
                        }
                    });
                }
                this.prevUserAnswersArray = cloneDeep(this.userAnswerArray);
                if (this.userAnswerArray.every(({ correct }) => correct)) {
                    this.$toasted.success(this.$i18n.t('trainer.trainer_gameFormSettingValue_success'));
                    this.rightAnswerGiven = true;
                }
                if (this.isOlympiad || this.isBattle || finishExample) {
                    this.nextExample();
                }
            },
            checkDoubledSigns(currentSymbol, futureSymbol) {
                const arr = ['&nbsp;', '.', ',', ':', ';'];
                return currentSymbol === '&nbsp;' && arr.includes(futureSymbol);
            },
            showRightAnswer() {
                this.showRightAnswersClicked = true;
            },
            showAnswerInDictationMode() {
                this.showAnswersInDictationMode = true;
            },
            registerSounds() {
                this.$createjs.Sound.removeAllSounds();
                this.$createjs.Sound.removeAllEventListeners();
                this.$createjs.Sound.alternateExtensions = ['mp3', 'ogg'];
                this.$createjs.Sound.registerSounds(this.soundObjects);
            },
            async getGameItems() {
                try {
                    if (
                        this.parameters.sourceText &&
                        this.parameters.sourceSound &&
                        this.parameters.amountOfExamples === 1 &&
                        !this.parameters.infinityAmountOfExamples
                    ) {
                        this.example = {
                            content: this.parameters.sourceText,
                            sound: this.parameters.sourceSound,
                        };
                    } else {
                        this.example = await orthographGameItems.get(this.parameters);
                    }
                    this.arrayOfDataForDictationMode.push(this.example);
                } catch (e) {
                    this.$toasted.error(this.$root.$t('errors.getting_level'));
                    this.$router.push({ name: 'dashboard' });
                }
            },
            async fetchData() {
                try {
                    await this.getExercise();
                    await this.getGameItems();
                    this.startGame();
                    this.registerSounds();
                    this.isLoading = false;
                } catch (e) {
                    this.$toasted.error(this.$root.$t('errors.getting_level'));
                    this.$router.push({ name: 'dashboard' });
                }
            },
            async nextExample() {
                this.stopAnswerTimer();
                this.currentLevel++;
                if (!this.isInfiniteAmountOfExamples && this.currentLevel > this.parameters.amountOfExamples) {
                    this.finishGame();
                    return;
                }
                this.givenAnswersInARow = 0;
                this.isLoading = true;
                this.rightAnswerGiven = false;
                this.showRightAnswersClicked = false;
                this.userAnswerArray = [];
                this.userAnswer = [];
                this.prevUserAnswersArray = [];
                await this.getGameItems();
                this.isLoading = false;
                this.startAnswerTimer();
            },
            finishGame() {
                this.gameFinished = true;
                this.stopTimer();
                if (!this.isDictationMode) {
                    this.soundInstance = this.$createjs.Sound.play('gameDone');
                    this.sendStat();
                }
            },
            refreshGameStatBeforeSend() {
                this.gameStat.answers = this.answers.good;
                this.gameStat.amountOfMistakes = this.answers.bad;
                this.gameStat.attempts = this.answers.good + this.answers.bad;
                this.gameStat.isCompleted = this.gameFinished;
                this.gameStat.executionTime = this.time;
                this.gameStat.isCorrect = true;
                this.gameStat.percent = this.calculatePercent();
                this.gameStat.amountOfExamples = this.currentLevel - 1;
                this.gameStat.parameters = cloneDeep(this.parameters);
            },
            calculatePercent() {
                let total = this.answers.good + this.answers.bad;
                if (total > 0) {
                    return parseInt((this.answers.good / total) * 100);
                }
                return 0;
            },
            startGame() {
                this.gameStarted = true;
                this.startTimer();
            },
            startTimer() {
                this.startAnswerTimer();
                this.$nextTick(() => {
                    if (!this.timer) {
                        this.setTimer();
                    }
                });
            },
            beforeGameRestart() {
                Object.assign(this, DEFAULT_DATA());
            },
        },
    };
</script>

<style scoped lang="scss">
    @import '@/assets/sass/games/playbox.scss';
    .play-box__end-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
    }

    .play-box__reaction-container {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        width: 100%;
        @include media($md) {
            flex-direction: row;
        }
    }

    .play-box__answers {
        font-weight: 500;
        font-size: 18px;
        line-height: 21px;
        text-align: center;
        @include media($md) {
            font-size: 22px;
            line-height: 26px;
        }
        @include media($lg) {
            font-size: 32px;
            line-height: 38px;
        }
        @include media($xl) {
            font-size: 42px;
            line-height: 50px;
        }
    }

    .play-box__image {
        max-width: 100%;
        margin-bottom: 30px;
        @include media($md) {
            margin-bottom: 40px;
        }
    }

    .play-box__game {
        display: flex;
        gap: 20px;
        flex-direction: column-reverse;
        align-items: center;
        justify-content: flex-end;
        width: 100%;
        @media screen and (min-width: 800px) {
            flex-direction: row;
            align-items: flex-start;
        }
    }

    .play-box__example {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        font-size: 7px;
        @include media($sm) {
            font-size: 8px;
        }
        @include media($md) {
            font-size: 9px;
        }
        @include media($lg) {
            font-size: 10px;
        }
    }

    .play-box__answer-buttons {
        display: flex;
        gap: 20px;
        justify-content: center;
        margin-top: 20px;
    }

    .play-box__field {
        padding: 0 20px;
        text-align: center;
        font-weight: bold;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        &-chunk {
            display: flex;
        }
        font-size: 7px;
        @include media($sm) {
            font-size: 8px;
        }
        @include media($md) {
            font-size: 9px;
        }
        @include media($lg) {
            font-size: 12px;
        }
        @include media($xl) {
            font-size: 14px;
        }
        @include media($xxl) {
            font-size: 16px;
        }
    }

    .play-box__marks {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        gap: 20px;
        margin-top: 20px;

        font-size: 7px;
        @include media($sm) {
            font-size: 8px;
        }
        @include media($md) {
            font-size: 9px;
        }
        @include media($lg) {
            font-size: 12px;
        }
        @include media($xl) {
            font-size: 14px;
        }
        @include media($xxl) {
            font-size: 16px;
        }
    }

    .play-box__mark {
        width: 2.2em;
        height: 2em;
        text-align: center;
        font-weight: bold;
        border-radius: 4px;
        border-width: 3px;
        border-style: solid;
        line-height: 0px;
        display: flex;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
        transition-duration: 100ms;
        &.selected {
            background: #2266ff;
            border-color: #2266ff;
            color: white;
        }
        &:not(.selected):hover {
            cursor: pointer;
            background: #93b3ff;
            border-color: #93b3ff;
        }
    }

    .play-box__mark-padding {
        padding-bottom: 0.5em;
    }

    .play-box__field-space {
        width: 1em;
        text-align: left;
        border-bottom-style: solid;
        border-bottom-width: 1px;
        border-bottom-color: transparent;
        &:not(.disabled):hover {
            border-radius: 4px;
            cursor: pointer;
            background: #00000026;
        }
        &.success {
            color: green;
            border-bottom-color: green;
        }
        &.error {
            color: red;
            border-bottom-color: red;
        }
    }

    .game-info__block {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        @media screen and (max-width: 800px) {
            &::v-deep .game-info {
                width: 100%;
            }
            &::v-deep .game-info__block {
                flex-direction: row;
                width: 100%;
                justify-content: space-between;
            }
        }
    }

    .trainer-modal-content__textarea {
        height: 260px;
        display: block;
        margin: 0px auto;
        width: 100%;
        line-height: 1.25;
        padding: 0.8em;
        resize: vertical;
        font-size: 20px;
        @include media($lg) {
            width: 80%;
            font-size: 24px;
        }
    }
    .divide-it-right__answer-buttom {
        display: flex;
        flex-direction: column;
        align-items: center;
        @include inset-space($space-base);
    }

    .divide-it-right__answer-turtle {
        max-width: 180px;
        @include stack-space($space-base);
        @include media($xlg) {
            max-width: 240px;
        }
    }

    .input-area {
        border: 1px solid #bdbdbd;
        box-sizing: border-box;
        border-radius: 5px;

        &:focus,
        &:active {
            outline: none;
        }

        &::placeholder {
            font-weight: lighter;
        }
    }

    .play-box__next-example-button {
        margin: 15px auto;
    }

    .checked-user-answer {
        min-width: 1em;
        display: flex;
        flex-wrap: wrap;
        box-sizing: border-box;
        padding: 0.8em;
        width: 100%;
        margin: 15px auto;
        @include media($lg) {
            width: 80%;
        }
    }

    .play-box__answers--left {
        color: $hsl-color-green-58;
        margin-left: 20px;
        @include media($lg) {
            margin-left: 35px;
        }
    }

    .play-box__answers--right {
        color: $hsl-color-green-58;
        margin-right: 20px;
        @include media($lg) {
            margin-right: 35px;
        }
    }
</style>
